import {Header} from "../components/Header";

export function App() {
  return <Header />;
}
